module.exports = __webpack_public_path__ + "img/jpg.57d57136.png";